<template>
 <div class="home">
  <div class="card banner-card">
    <img src="/banner.png" alt="A igreja é a sua casa" class="banner-img" />
  </div>
  <CardPicture v-if="lastPreaching" :lastPreaching="lastPreaching" />
  <div class="card resume">
   <div class="resumo-cultos">
    <p>CULTOS</p>
    <span> Quinta: <b>{{ churchInfo.horario_quinta || '19:30' }}</b> </span>
    <span> Sábado:</span>
    <span> Aliança Teen <b>{{ churchInfo.horario_sabado_teen || '17:00' }}</b> </span>
    <span> Aliança Jovem <b>{{ churchInfo.horario_sabado_jovem || '19:30' }}</b> </span>
    <span> Domingo: <b>{{ churchInfo.horario_domingo_manha || '9:00' }} | {{ churchInfo.horario_domingo_tarde || '17:00' }} | {{ churchInfo.horario_domingo_noite || '19:30' }}</b> </span>
   </div>
   <div class="line"></div>
   <div class="proximo-evento">
    <p>PRÓXIMO EVENTO</p>
    <span>{{ nextEventDate }}</span>
    <b>{{ nextEventTitle }}</b>
   </div>
   <div class="line"></div>
   <Socials />
  </div>

  <!-- Matrículas -->
  <a v-if="churchInfo.matriculas_url" :href="churchInfo.matriculas_url" target="_blank" class="card matriculas-banner">
    <i class="fa fa-pencil-square-o matriculas-icon"></i>
    <div class="matriculas-text">
      <strong>Matrículas das Escolas</strong>
      <span>Inscreva-se agora</span>
    </div>
    <i class="fa fa-chevron-right matriculas-chevron"></i>
  </a>

  <!-- Quick Links -->
  <div v-if="quickLinks.length > 0" class="quick-links-row">
    <a v-for="link in quickLinks" :key="link.id" :href="link.url" target="_blank" class="card quick-link-item">
      <i :class="link.fa_icon || 'fa fa-link'" class="ql-icon"></i>
      <span class="ql-title">{{ link.title }}</span>
    </a>
  </div>

  <div id="events" v-for="event in events" :key="event.id">
    <CardEvent
     :key="event.id"
     :img-src="event.imgSrc"
     :title="event.title"
     :date="event.date"
     :description="event.description"
     :link="event.link"
    />
  </div>

  <ChurchMap
    id="como-chegar"
    :latitude="latitude"
    :longitude="longitude"
    :church-name="churchInfo.church_name"
  />

  <CtaCards :church-info="churchInfo" />
 </div>
</template>

<script>
import CardPicture from "@/components/CardPicture.vue";
import Socials from "@/components/Socials.vue";
import CardEvent from "@/components/CardEvent.vue";
import ChurchMap from "@/components/ChurchMap.vue";
import CtaCards from "@/components/CtaCards.vue";
import axios from "axios";
import { pickLatestValid } from "@/utils/preachings.js";

const API_URL = process.env.VUE_APP_API_URL

export default {
 name: "HomeVue",
 components: { CardPicture, Socials, CardEvent, ChurchMap, CtaCards },
 props: {
  latitude: Number,
  longitude: Number,
  churchInfo: {
    type: Object,
    default: () => ({})
  },
 },
data() {
 return {
  events: [],
  lastPreaching: null,
  nextEventTitle: "",
  nextEventDate: "",
  quickLinks: [],
 };
},
mounted() {
    this.getEvents();
    this.getLatestPreaching();
    this.getQuickLinks();
},
 methods: {
  async getEvents() {
   try {
    const response = await axios.get(`${API_URL}/events`);
    const data = Array.isArray(response.data) ? response.data : response.data.data || []
    this.events = data
        .map((event) => ({
            id: event.id,
            imgSrc: event.banner_url || '',
            dateOriginal: event.start_event,
            date: this.formatEventDate(event.start_event, event.end_event),
            title: event.name,
            description: event.description,
            link: event.link
        }))
        .sort((a, b) => new Date(a.dateOriginal) - new Date(b.dateOriginal))
   } catch {
    this.events = []
   }
  },
  async getLatestPreaching() {
   try {
    const response = await axios.get(`${API_URL}/preachings`);
    const list = Array.isArray(response.data) ? response.data : response.data.data || []
    const preaching = pickLatestValid(list)
    if (!preaching) {
      this.lastPreaching = null
      return
    }
    this.lastPreaching = {
        id: preaching.id,
        title: preaching.name,
        minister: preaching.minister,
        youtube_link: preaching.youtube_link,
        published_at: preaching.published_at,
    }
   } catch {
    this.lastPreaching = null
   }
  },
  async getQuickLinks() {
   try {
    const response = await axios.get(`${API_URL}/quick-links`);
    this.quickLinks = Array.isArray(response.data) ? response.data : response.data.data || []
   } catch {
    this.quickLinks = []
   }
  },
  formatEventDate(startDateStr, endDateStr) {
        const months = [
            'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
            'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'
        ]

        const startDate = new Date(startDateStr)
        const endDate = new Date(endDateStr)

        const startDay = startDate.getDate()
        const endDay = endDate.getDate()

        const startMonth = months[startDate.getMonth()]
        const endMonth = months[endDate.getMonth()]

        if (startDay === endDay && startMonth === endMonth) {
            return `${startDay} de ${startMonth}`
        } else if (startMonth === endMonth) {
            return `${startDay} a ${endDay} de ${startMonth}`
        } else {
            return `${startDay} de ${startMonth} a ${endDay} de ${endMonth}`
        }
    }
},
watch: {
    events: {
        handler: function (newEvents) {
        if (newEvents.length > 0) {
            this.nextEventTitle = newEvents[0].title;
            this.nextEventDate = newEvents[0].date;
        }
        },
        deep: true,
    },
},
};
</script>

<style scoped>
.home {
 display: flex;
 flex-direction: column;
 gap: 40px;
 align-items: center;
}

.resume {
 color: #666;
 display: flex;
 justify-content: center;
 gap: 80px;
 align-items: center;
}

.resumo-cultos,
.proximo-evento {
 display: flex;
 flex-direction: column;
 gap: 2px;
 align-items: center;
}

#events {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.resumo-cultos p {
  margin-bottom: -2px;
}

.line {
 width: 0.5px;
 height: 70px;
 background: #333;
 opacity: 0.5;
}

/* Banner */
.banner-card {
  padding: 0 !important;
  overflow: hidden;
  max-width: 1080px;
  width: 100%;
  box-sizing: border-box;
}

.banner-img {
  display: block;
  width: 100%;
  height: auto;
}

/* Matrículas */
.matriculas-banner {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 22px 30px !important;
  text-decoration: none;
  color: #2c3e50;
  max-width: 1080px;
  width: 100%;
  box-sizing: border-box;
  transition: box-shadow 0.25s ease;
}

.matriculas-banner:hover {
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
}

.matriculas-icon {
  font-size: 22px;
  color: #3366cc;
  width: 40px;
  text-align: center;
}

.matriculas-text {
  flex: 1;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.matriculas-text strong {
  font-size: 15px;
  color: #2c3e50;
}

.matriculas-text span {
  font-size: 13px;
  color: #999;
}

.matriculas-chevron {
  font-size: 14px;
  color: #ccc;
}

/* Quick Links */
.quick-links-row {
  display: flex;
  gap: 16px;
  width: 100%;
  max-width: 1080px;
}

.quick-link-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 20px 24px !important;
  text-decoration: none;
  color: #2c3e50;
  transition: box-shadow 0.25s ease;
}

.quick-link-item:hover {
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
}

.ql-icon {
  font-size: 18px;
  color: #3366cc;
  width: 24px;
  text-align: center;
}

.ql-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

@media screen and (max-width: 981px) {
 .resume {
  flex-direction: column;
  gap: 20px;
 }
 .line {
  width: 150px;
  height: 0.5px;
 }
 .quick-links-row {
  flex-direction: column;
 }
}
</style>
